import momtaz1 from '../assets/images/projects/momtaz/momtaz-homepage-teachers-listing-search-teacher-profile.jpg'
import momtaz2 from '../assets/images/projects/momtaz/momtaz-teacher-availability-work-schedule.jpg'
import momtaz3 from '../assets/images/projects/momtaz/momtaz-teacher-booking-flow.png'
import momtaz4 from '../assets/images/projects/momtaz/momtaz-teacher-profile-creation.jpg'
import project1 from '../assets/images/project-1.png'
import project12 from '../assets/images/project-1-2.png'
import project13 from '../assets/images/project-1-3.png'
import project14 from '../assets/images/project-1-4.png'
import project15 from '../assets/images/project-1-5.png'
import project16 from '../assets/images/project-1-6.png'
import project17 from '../assets/images/project-1-7.png'
import project18 from '../assets/images/project-1-8.png'

import project2 from '../assets/images/project-2.png'
import project22 from '../assets/images/project-2-2.png'
import project23 from '../assets/images/project-2-3.png'
import project24 from '../assets/images/project-2-4.png'

import project3 from '../assets/images/project-3.png'
import project32 from '../assets/images/project-3-2.png'
import project33 from '../assets/images/project-3-3.png'
import project34 from '../assets/images/project-3-4.png'
import project35 from '../assets/images/project-3-5.png'
import project36 from '../assets/images/project-3-6.png'
import project37 from '../assets/images/project-3-7.png'

import project4 from '../assets/images/project-4.png'
import project42 from '../assets/images/project-4-2.png'
import project43 from '../assets/images/project-4-3.png'
import project44 from '../assets/images/project-4-4.png'
import project45 from '../assets/images/project-4-5.png'
import project46 from '../assets/images/project-4-6.png'

import project5 from '../assets/images/project-5.png'
import project52 from '../assets/images/project-5-2.png'
import project53 from '../assets/images/project-5-3.png'
import project54 from '../assets/images/project-5-4.png'
import project55 from '../assets/images/project-5-5.png'
import project56 from '../assets/images/project-5-6.png'

import pangaea1 from '../assets/images/projects/pangaea/pangaea-b2b-desktop.jpg'
import pangaea2 from '../assets/images/projects/pangaea/pangaea-b2b-mobile.jpg'
import pangaea3 from '../assets/images/projects/pangaea/pangaea-booking-flow-desktop.jpg'
import pangaea4 from '../assets/images/projects/pangaea/pangaea-booking-flow-mobile.jpg'
import pangaea5 from '../assets/images/projects/pangaea/pangaea-hero-dropdown.jpg'
import pangaea6 from '../assets/images/projects/pangaea/pangaea-homepage.jpg'
import pangaea7 from '../assets/images/projects/pangaea/pangaea-mobile-app-navigation.jpg'
import pangaea8 from '../assets/images/projects/pangaea/pangaea-trip-page.jpg'
import pangaea9 from '../assets/images/projects/pangaea/same-day-trip-booking-flow.jpg'
import project6 from '../assets/images/project-6.png'
import project62 from '../assets/images/project-6-2.png'
import project63 from '../assets/images/project-6-3.png'
import project64 from '../assets/images/project-6-4.png'
import project65 from '../assets/images/project-6-5.png'

import project7 from '../assets/images/project-7.png'
import project72 from '../assets/images/project-7-2.png'
import project73 from '../assets/images/project-7-3.png'
import project74 from '../assets/images/project-7-4.png'
import project75 from '../assets/images/project-7-5.png'

import project8 from '../assets/images/project-8.png'
import project82 from '../assets/images/project-8-2.png'
import project83 from '../assets/images/project-8-3.png'
import project84 from '../assets/images/project-8-4.png'
import project85 from '../assets/images/project-8-5.png'

import project9 from '../assets/images/project-9.png'
import project92 from '../assets/images/project-9-2.png'

import project10 from '../assets/images/project-10.png'
import project102 from '../assets/images/project-10-2.png'
import project103 from '../assets/images/project-10-3.png'

import project11 from '../assets/images/project-11.png'
import project112 from '../assets/images/project-11-2.png'
import project113 from '../assets/images/project-11-3.png'
import project114 from '../assets/images/project-11-4.png'
import project115 from '../assets/images/project-11-5.png'

import project121 from '../assets/images/project-12-1.png'
import project122 from '../assets/images/project-12-2.png'

import dp from '../assets/images/performance-dp.png'
import resal from '../assets/images/performance-resal.png'
import pangaea from '../assets/images/performance-pangaea.png'
import peanut from '../assets/images/performance-peanut.png'
import aanaab from '../assets/images/performance-aanaab.png'
import aanaabjobs from '../assets/images/performance-aanaabjobs.png'

export const projects = [
    {
        id: 1,
        projectName: "Momtaz Platform",
        describtion: "Feel free to check out the Project by visiting the Live Link.",
        thumbnail: project1,
        images: [momtaz1, momtaz2, momtaz3, momtaz4, project1, project12, project13, project14, project15, project16, project17, project18],
        clr: "#eaddf9",
        liveDemo: 'https://momtaz-mohammedsobhi.netlify.app/',
        usedTools: ['react js', 'tailwindcss', 'javascript', 'css3', 'es6', 'html']
    },
    {
        id: 2,
        projectName: "DesignPeer Company",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project2,
        images: [project2, project22, project23, project24, dp],
        clr: "#8859fa",
        liveDemo: 'https://mohamedsobhi70.github.io/designpeer/',
        usedTools: ['html5', 'javascript', 'css3', 'jquery', 'es6', 'tailwindcss']
    },

    {
        id: 3,
        projectName: "Warraq E-Commerce",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project4,
        images: [project4, project42, project43, project44, project45, project46],
        clr: "#3da2b8",
        liveDemo: 'https://mohamedsobhi70.github.io/warraq/',
        usedTools: ['html', 'javascript', 'css3', 'tailwindcss', 'jquery']
    },
    {
        id: 4,
        projectName: "Aanaab Jobs",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project5,
        images: [project5, project52, project53, project54, project55, project56, aanaabjobs],
        clr: "#8d51ff",
        liveDemo: 'https://mohamedsobhi70.github.io/aanaab',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3', 'jquery']
    },
    {
        id: 5,
        projectName: "Aanaab Schools",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project6,
        images: [project6, project62, project63, project64, project65, aanaab],
        clr: "#8447ff",
        liveDemo: 'https://mohamedsobhi70.github.io/aanaabschools/',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3', 'jquery']
    },
    {
        id: 6,
        projectName: "Pangaea Trips",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project7,
        images: [pangaea1, pangaea2, pangaea3, pangaea4, pangaea5, pangaea6, pangaea7, pangaea8, pangaea9, project7, project72, project73, project74, project75, pangaea],
        clr: "#309c98",
        liveDemo: 'https://mohamedsobhi70.github.io/pangaea/',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3', 'jquery']
    },
    {
        id: 7,
        projectName: "Resal Platform",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project8,
        images: [project8, project82, project83, project84, project85, resal],
        clr: "#2525ff",
        liveDemo: 'https://mohamedsobhi70.github.io/resalnew/',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3', 'jquery']
    },
    {
        id: 8,
        projectName: "Peanuts E-Commerce",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project3,
        images: [project3, project32, project33, project34, project35, project36, project37, peanut],
        clr: "#f7ab4b",
        liveDemo: 'https://peanuts-mohammedsobhi.netlify.app/',
        usedTools: ['React js', 'tailwindcss', 'javascript', 'css3', 'jquery']
    },
    {
        id: 9,
        projectName: "Mohanned Blog",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project9,
        images: [project9, project92],
        clr: "#b63f36",
        liveDemo: 'https://mohamedsobhi70.github.io/mohanned',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3']
    },
    {
        id: 10,
        projectName: "Jywar",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project10,
        images: [project10, project102, project103],
        clr: "#0cb0a6",
        liveDemo: 'https://mohamedsobhi70.github.io/jywar',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3']
    },
    {
        id: 11,
        projectName: "enduvo",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project11,
        images: [project11, project112, project113, project114, project115],
        clr: "#f8ba17",
        liveDemo: 'https://mohamedsobhi70.github.io/enduvo',
        usedTools: ['html', 'tailwindcss', 'javascript', 'css3']
    },
    {
        id: 12,
        projectName: "Dashboard",
        describtion: "The fact that photography has different meanings to different people is one of the many components of its appeal. Photography is such an important part of our life that it is now very difficult to imagine the world without it. We cannot imagine a wedding without the opportunity to capture it on film, we would not be able to remember the growing up of children or the holidays if we did not have pictures.",
        thumbnail: project121,
        images: [project121, project122],
        clr: "red",
        liveDemo: 'https://mohamedsobhi70.github.io/dashboard/',
        usedTools: ['html', 'javascript', 'css3']
    },
]